export default {
	name: 'OrdersView'
}